import React, { useContext } from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import Typography from "@material-ui/core/Typography";
import ProductDetailContext from "@micado-digital/react-shop/ProductDetail/context/ProductDetailContext";
import ProductDocuments from "@micado-digital/react-shop/views/ProductDetail01/Documents";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import Local from "@micado-digital/react-ui/components/Local";
import localDE from "@micado-digital/react-shop/locals/de.json";
import localEN from "@micado-digital/react-shop/locals/en.json";
import localIT from "@micado-digital/react-shop/locals/it.json";

import styles from "./Documents.styles";

const Documents = ({ lang }) => {
	const { productDetailData } = useContext(ProductDetailContext);
	const { documents } = productDetailData || {};
	const css = styles();
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN,
			it: localIT
		}
	});

	if (isEmpty(documents)) return <></>;

	return (
		<div className={clsx(css.documents, "mco-shop-product-detail-documents")}>
			<Typography className={css.headline} variant="h4">
				<span>
					<Local identifier="reactShop.productDetail.title.documents" l={l} />
				</span>
			</Typography>
			<ProductDocuments lang={lang} />
		</div>
	);
};

export default Documents;
